<app-ace-select
  #aceselect
  [items]="clients"
  [multiSelect]="multiSelect"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [loading]="loading"
  [hideSelected]="false"
  [appendTo]="DROPDOWN_HOLDER_SELECTOR"/>
